import React from "react";
import Image from "next/image";
import { CardsWrapper, Card } from "styles/cards";
import { ParagraphText, TextHeadingTwo } from "styles/typography";
import { IconWrapper } from "styles/wrappers";
import { AffiliateProgramsList } from "./affiliate-programs.utils";

const AffiliatePrograms = () => {
   return (
      <CardsWrapper col={3} gap={2.5}>
         {AffiliateProgramsList.map((item) => (
            <Card key={item.id}>
               <IconWrapper
                  style={{
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     width: 50,
                     marginBottom: 20,
                  }}
               >
                  <Image src={item.icon} alt={item.title} />
               </IconWrapper>
               <TextHeadingTwo>{item.title}</TextHeadingTwo>
               <ParagraphText>{item.descriptiom}</ParagraphText>
            </Card>
         ))}
      </CardsWrapper>
   );
};

export { AffiliatePrograms };
